import dagre from 'dagre';
import { isEdge, isNode } from 'react-flow-renderer';

const dagreGraph = new dagre.graphlib.Graph();
dagreGraph.setDefaultEdgeLabel(() => ({}));

const nodeWidth = 300;
const nodeHeight = 70;

const completeNode = (dagreGraph, node) => {
  const nodeWithPosition = dagreGraph.node(node.id)
  return {
    ...node,
    position: {
      x: nodeWithPosition.x - nodeWidth / 2 + Math.random() / 1000,
      y: nodeWithPosition.y - nodeHeight / 2,
    },
  }
}

export const getLayoutedElements = (elements) => {
  const isHorizontal = true;
  dagreGraph.setGraph({ rankdir: "LR" });

  //console.log(elements)
  elements
  .forEach((el) => {
    if (isNode(el)) {
      dagreGraph.setNode(el.id, { width: nodeWidth, height: nodeHeight });
    } else {
      dagreGraph.setEdge(el.source, el.target);
    }
  });

  dagre.layout(dagreGraph);

  return elements.map((el) => 
    isNode(el) ? completeNode(dagreGraph, el) : el
  )
};

export const resolveNodoRel = (id, idPadre, handle, label, onEdit, data = {}) => {
  //console.log(data)
  return {
    id: `e${idPadre}-${id}`,
    label: "",
    source: idPadre,
    target: id,
    //sourceHandle: handle,
    animated: true,
    style: { stroke: data.color },
    arrowHeadType: 'arrow',
    type: "EdgeButton",
    data: {
      onEdit,
      ...data,
    }
  };
};

export const getTargetsNodes = (edgeId, elements) => {
  const edge = elements.find(el => el.id === edgeId);
  const nodeSource = elements.find(el => el.id === edge.source);
  const edges = elements.filter(el => el.source === nodeSource.id && el.id !== edgeId);
  const nodeTargets = edges.map(e => elements.find(el => el.id === e.target));
  return nodeTargets;
}

const getParentsNodes = (id, elements) => {

  const element = elements.find(el => el.id===id);
  if(!element) return [];



  const parentsId = isNode(element) 
    ? elements.filter(el => el.target===id).map(el => el.source)
    : [element.source];

  const parents = parentsId.map(parentId => elements.find(el => el.id === parentId))

    return parents;
}

export const getAllParentsNodes = (id, elements, collector = []) => {
  
  const parents = getParentsNodes(id, elements).filter(parent => !collector.some(item => item.id === parent.id));

  const result = parents.reduce( (prev, curr) => {
    const allParents = getAllParentsNodes( curr.id, elements, [curr, ...collector]);
    return curr ? [...prev, ...allParents] : prev;
  }, parents);
  
  return result;

}

export const resolveNodo = ({id, type = "NodeBasic", data, xPos, yPos, onEdit, onRemove}) => {
  const newId = id || uuid();
  return {id: newId, position: {x: xPos , y: yPos}, type, data: {...data, id: newId, label:"", onEdit, onRemove}};
};

export const resolveElement = ({el, onEdit, onRemove, onEdgeEdit}) => {
  if(el.source && el.target) return resolveNodoRel(el.target, el.source, el.sourceHandle, "", onEdgeEdit, el.data);
  return resolveNodo({...el, xPos: el.position.x, yPos: el.position.y, onEdit, onRemove});
}

const nodosToFlowElements = ({nodos, onEdit, onRemove, onEdgeEdit}) => {
  //console.log(onEdit)
  const result = nodos.reduce((prev, curr) => {
    return curr.hijos.length === 0
      ? [...prev, resolveNodo({...curr, onEdit, onRemove})]
      : [
          ...prev,
          resolveNodo({...curr, onEdit, onRemove}),
          ...nodosToFlowElements({nodos: curr.hijos, onEdit, onRemove, onEdgeEdit}),
          ...curr.hijos.map((x) => resolveNodoRel(x.id, curr.id, x.handle, undefined, onEdgeEdit))
        ];
  }, []);
  return result;
};

const flowElementsToNodos = (hijos, items) => {
  return hijos.reduce(
    (prev, curr) => [
      ...prev,
      {
        ...curr,
        hijos: flowElementsToNodos(findRel(curr.id, items), items)
      }
    ],
    []
  );
};

const findRel = (id, items) => {
  return items
    .filter((x) => x.source === id)
    .map((x) => items.find((i) => i.id === x.target));
};

export const uuid = () => {
  const url = URL.createObjectURL(new Blob())
  const [id] = url.toString().split('/').reverse()
  URL.revokeObjectURL(url)
  return id
}